import { render, staticRenderFns } from "./ImagesGrid.vue?vue&type=template&id=8b0550f4&scoped=true&"
import script from "./ImagesGrid.vue?vue&type=script&lang=js&"
export * from "./ImagesGrid.vue?vue&type=script&lang=js&"
import style0 from "./ImagesGrid.vue?vue&type=style&index=0&id=8b0550f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0550f4",
  null
  
)

export default component.exports